<template>
	<ul v-if="items">
		<template v-for="(group, i) of items">
			<li  v-if="checkMenu(group.id, group.items)"  :key="i"  class="group-class"> <a >{{ group.label }}</a></li>
			<template v-if="group.items" >
				<li v-for="(item, j) of group.items"  :key="'sub-' + i + '-' + j" :class="[{'active-menuitem': ((activeIndex === j && !item.to))}]">
					<template v-if="checkDisplayMenu(item.id)" >
						<a :id="item.id" :href="item.to" v-if="item.to" :class="[(activeItemGroup(item.id)) ? 'active-route' : '']"  :target="item.target" exact>
							<!-- @click="onMenuItemClick($event,item,j)" -->
							<i :class="item.icon"></i>
							<span>{{item.label}}</span>
							<i v-if="item.items" class="pi pi-fw pi-angle-down menuitem-toggle-icon"></i>
							<span v-if="item.badge" class="menuitem-badge">{{item.badge}}</span>
						</a>
					</template>
				</li>
			</template>
		</template>
	</ul>
</template>
<script>
export default {
	name: 'AppSubmenu',
	props: {
		items: Array,
		root: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			activeIndex : null,
			activeItem: null
		}
	},
	methods: {
		checkMenu(id, items) {
			if (items != undefined && items) {
				for (let index = 0; index < items.length; index++) {
					var item = items[index];
					var check = this.$myConstants.checkDisplayMenu(this.$store.getters.permission, item.id);
					if(check) return true;
				}
			}
			return false;
		},
		checkDisplayMenu(id) {
			return this.$myConstants.checkDisplayMenu(this.$store.getters.permission, id);
		},
		activeGroup(id) {
			return  id == this.$route.meta.group;
		},
		activeItemGroup(id) {
			return id == this.$route.name || (this.$route.meta.childs != undefined && this.$route.meta.childs.includes(id));
		},
		onMenuItemClick(event, item, index) {
			if (item.disabled) {
				event.preventDefault();
				return;
            }
            
            if (!item.to && !item.url) {
                event.preventDefault();
            }

			//execute command
			if (item.command) {
                item.command({originalEvent: event, item: item});
			}
			this.activeIndex = index === this.activeIndex ? null : index;
			this.$emit('menuitem-click', {
				originalEvent: event,
				item: item
			});
		}
	}
}
</script>

<style scoped>

</style>